export function getPercentageChange(start, end) {
  if (!start) return 0;
  return parseFloat(((100 * (end - start)) / start).toFixed(0));
}
